<template>
  <GridPart
      maxWidth="calc(100% - 40px)"
      :title="title"
      :hasSearch="true"
      :hasFilter="false"
      :hasExtra="true"
      :standardClass="() => {}"
      :extraClass="() => {}"
      :colspan="6"
      empty="Nenašli sa žiadne výkazy."
      itemsKey="ticketItemReports"
      filterKey="TicketItemReport"
      defaultOrder="ticiterep.workedAt"
      defaultBy="DESC"
      :defaultLimit="25"
      :fetchData="fetchData"
  >
    <template
        v-slot:search="{
          params,
          errors,
          setSearch
        }"
    >
      <v-text-field
          v-model="params.query"
          :error-messages="errors.query"
          :outlined="true"
          :dense="true"
          hide-details="auto"
          label="Vyhľadávanie"
          :clearable="true"
          @change="setSearch"
      />
    </template>

    <template
        v-slot:list-head="{
          order,
          by,
          orderList,
          byList,
          setOrderBy
        }"
    >
      <th
          class="fixed"
      >
        <OrderList
            orderKey="ticiterep.workedAt"
            :order="order"
            :by="by"
            :orderList="orderList"
            :byList="byList"
            @setOrderBy="setOrderBy"
        />
      </th>

      <th>
        Užívateľ
      </th>

      <th>
        Odpracovaný čas
      </th>

      <th>
        Plat
      </th>

      <th>
        Odpracovaná suma
      </th>

      <th
          class="text-right fixed"
      />
    </template>

    <template
        v-slot:list-body-standard="{
          Item,
          init
        }"
    >
      <td
          class="fixed"
      >
        {{ Item.workedAt|moment('DD.MM.YYYY') }}
      </td>

      <td>
        <TruncateHelper
            :title="Item.User.name"
            maxWidth="300px"
        >
          {{ Item.User.name }}
        </TruncateHelper>
      </td>

      <td>
        {{ Item.timeSpend|number }} h
      </td>

      <td>
        {{ Item.priceHour|currency('€ / h') }}
      </td>

      <td>
        {{ Item.priceSpend|currency('€') }}
      </td>

      <td
          class="text-right fixed"
      >
        <template
            v-if="Item.updatable"
        >
          <Update
              :id="Item.id"
              @onUpdate="(response) => {
                init()

                $emit('refresh', response)
              }"
          />
        </template>
      </td>
    </template>

    <template
        v-slot:list-body-extra="{
          Item
        }"
    >
      <td
          :colspan="6"
      >
        <IsEmptyHelper
            :value="Item.note"
            if-no="i"
            if-yes="i"
            empty="bez poznámky"
        >
          {{ Item.note }}
        </IsEmptyHelper>

        <template
            v-if="Item.files.length > 0"
        >
          <template
              v-for="(_File) in Item.files"
          >
            <br
                :key="_File.id + 'br'"
            />

            <a
                :key="_File.id + 'a'"
                :href="$global.axiosUrl() + 'files/'  + _File.token + '/generate/original'"
                target="_blank"
            >
              {{ _File.name }}
            </a>
          </template>
        </template>
      </td>
    </template>
  </GridPart>
</template>

<script>
  import TicketItemReports from '@/services/ticket-item-reports'

  import Update from '@/components/TicketItemReports/Update'

  import GridPart from '@/components/_Part/Grid'

  import OrderList from '@/components/_Part/_Grid/_List/Order'

  import TruncateHelper from '@/components/_Part/_Helper/Truncate'
  import IsEmptyHelper from '@/components/_Part/_Helper/IsEmpty'

  export default {
    name: 'TicketItemReports',
    props: [
      'Ticket'
    ],
    emits: [
      'refresh'
    ],
    components: {
      Update,
      GridPart,
      OrderList,
      TruncateHelper,
      IsEmptyHelper
    },
    data() {
      return {
        title: 'Výkazy'
      }
    },
    methods: {
      fetchData(params) {
        return TicketItemReports
          .indexTicket({
            ticketId: this.Ticket.id,
            params: params
          })
      }
    }
  }
</script>
